import React from 'react'

import { ButtonClean, Icon, Tooltip, useCopyToClipboard } from '@fourthwall/components'
import { DuplicateIcon, TickIcon } from '@fourthwall/icons'

import * as S from './HMACDisplay.styled'

type HMACDisplayProps = {
  hmac?: string
}

export const HMACDisplay = ({ hmac }: HMACDisplayProps) => {
  const { isCopied, copyToClipboard } = useCopyToClipboard()
  if (!hmac) return null

  const truncatedHmac = hmac.length > 50 ? `${hmac.substring(0, 50)}...` : hmac

  return (
    <S.Container>
      <S.HMACContainer>
        <div>{truncatedHmac}</div>
        <div>
          {isCopied ? (
            <Tooltip reference={<Icon component={TickIcon} height={12} />}>Copied!</Tooltip>
          ) : (
            <Tooltip
              reference={
                <ButtonClean label="" icon={DuplicateIcon} onClick={() => copyToClipboard(hmac)} />
              }
            >
              Copy
            </Tooltip>
          )}
        </div>
      </S.HMACContainer>
    </S.Container>
  )
}
